<template>
  <div style="position: relative;min-height: 100vh;padding-bottom: 100px;">
    <Header class="is-uppercase has-text-weight-bold" />
    <div style="min-height: 75vh;">
      <slot></slot>
    </div>
    <Footer class="is-uppercase has-text-weight-bold" style="width: 100%;bottom: 0px;left:0;" />
  </div>
</template>

<script>
import Header from '@/components/LangGG/Header'
import Footer from '@/components/LangGG/Footer'
import axios from 'axios'

export default {
  name: 'LayoutGG',
  async mounted() {
    if (this.$store.getters.requireSaleId && window !== undefined && window.localStorage instanceof Storage) {
      const saleIdArr = window.location.hash.match(/\?saleId=([a-z0-9]+)/)
      if (saleIdArr instanceof Array && saleIdArr.length == 2) {
        window.localStorage.setItem('saleId', saleIdArr[1])
      }

      const result = await axios.get(`/${ this.$store.getters.apiPrefix }/checkSale/${ window.localStorage.getItem('saleId') }`)
      if (result.data.state === 'unknown') {
        this.$router.push({ name: 'Login' })
      }
    }
  },
  components: {
    Header,
    Footer
  }
}
</script>




// WEBPACK FOOTER //
// src/layouts/GG.vue